/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { RoutePath } from 'shared/enums/RoutePath';
import history from '../../../../history';
import { keycloakService } from '../../auth/auth.service';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';
import { getUserThunk } from '../../user/userAccounts/userAccounts.thunk';

/* Thunks */
export const deleteRemoveOrganizationThunk = createFOAsyncThunk('organization/removeOrg', async (args) => {
  return userApi.removeOrganization(args.orgId, 'false');
});

export const deleteValidateRemoveOrganizationThunk = createFOAsyncThunk(
  'organization/validateRemoveOrg',
  async (args, { rejectWithValue }) => {
    try {
      return await userApi.removeOrganization(args.orgId, 'true');
    } catch (error) {
      if (error.response && error.response.status === 412) {
        const { data } = error.response;
        return rejectWithValue({ showAlert: false, data });
      }
      throw error;
    }
  },
);

export const postDeleteOrganizationThunk = createFOAsyncThunk(
  'organization/postRemoveOrg',
  async (userId, thunkApi) => {
    const changed = await keycloakService.refreshToken({ force: true });
    if (changed) {
      await thunkApi.dispatch(getUserThunk(userId));
      history.replace(RoutePath.generateRoutePath(RoutePath.SWITCH_ACCOUNT, {}));
    }
  },
);
